<template>
  <div v-if="content.show">
    <TextInput v-if="content.type==6" :content="content" v-on:listenToChildEvent="getText"></TextInput>
    <div v-if="content.type==7">
      <p>{{content.title}}</p>
      <ul class="category-box">
        <li class="category-list" :class="show[index]?'half-opacity':'option-select'" @click="selectCategory(item,index)"
        v-for="(item,index) in content.options">
          <span>{{item}}</span>
        </li>
      </ul>
    </div>
  </div>
</template>
<!--多答案-->
<script>
import TextInput from '../components/TextInput'
export default {
  props:{
    content:Object
  },
  components: {
    'TextInput':TextInput
  },
  data(){
    return{
      show:[true,true,true,true],
    }
  },
  created(){
    this.listCareer = this.content
  },
  methods:{
    // 设置第一题的答案
    getText(text,num,type){
      this.$emit("listenToChildEvent",text,num);
    },
    // 设置第二题的答案
    selectCategory(text,i){
      let value=[true,true,true,true]
      value[i] = false
      this.show = value
      this.$emit("listenToChildEvent",i,2)
    }
  }
}
</script>
<style lang="stylus" scoped>
  .category-box
    .category-list
      height:1.2rem
      max-width:70%
      padding:0.2rem
      margin:0.3rem auto
      font-size:0.36rem
      color:#ffffff
      display: flex
      display:-webkit-flex;
      justify-content: center/*水平居中*/
      align-items: center/*垂直居中*/
      -webkit-align-items:center
      span
        opacity:1
    .category-list:nth-child(1)
      background-color:#8C0061
    .category-list:nth-child(2)
      background-color:#F15769
    .category-list:nth-child(3)
      background-color:#FAD309
    .category-list:nth-child(4)
      background-color:#C1D659
    .half-opacity
      opacity:0.6
    .option-select
      padding:0.3rem 0.4rem
</style>
